import { isWhole } from "./quantity.js";
/** A category branch lists goods or services (CAT-2, decided 2026-09-27); every listing takes its branch's kind. */
export const LISTING_KINDS = ["goods", "service"];
/** Goods are in stock, made to order, or unavailable; a service is available or not (CAT-6). */
export const AVAILABILITY = ["in_stock", "made_to_order", "available", "unavailable"];
const GOODS_AVAILABILITY = ["in_stock", "made_to_order", "unavailable"];
const SERVICE_AVAILABILITY = ["available", "unavailable"];
const HS_CODE = /^\d{6,10}$/;
const COUNTRY = /^[A-Z]{2}$/;
/**
 * What a listing of each kind needs before it can be submitted (card 034). Goods carry an HS code, origin, and
 * shipping-related availability and may offer a sample; a service states the countries where it is offered and has
 * no HS code, origin, quantity, or sample. A draft may be incomplete; submission checks this.
 */
export function kindIssues(kind, fields) {
    const issues = [];
    if (fields.leadTimeDays === null)
        issues.push({ path: "leadTimeDays", code: "REQUIRED" });
    else if (!isWhole(fields.leadTimeDays) || fields.leadTimeDays < 0 || fields.leadTimeDays > 730)
        issues.push({ path: "leadTimeDays", code: "OUT_OF_RANGE" });
    if (kind === "goods") {
        if (fields.hsCode === null)
            issues.push({ path: "hsCode", code: "REQUIRED" });
        else if (!HS_CODE.test(fields.hsCode))
            issues.push({ path: "hsCode", code: "INVALID_HS_CODE" });
        if (fields.originCountry === null)
            issues.push({ path: "originCountry", code: "REQUIRED" });
        else if (!COUNTRY.test(fields.originCountry))
            issues.push({ path: "originCountry", code: "INVALID_COUNTRY" });
        if (fields.serviceRegions !== null)
            issues.push({ path: "serviceRegions", code: "NOT_FOR_GOODS" });
        if (!GOODS_AVAILABILITY.includes(fields.availability))
            issues.push({ path: "availability", code: "NOT_FOR_GOODS" });
        if (fields.availableQuantity !== null && fields.availableQuantity < 0n)
            issues.push({ path: "availableQuantity", code: "INVALID_QUANTITY" });
        if (fields.sample !== null && fields.sample.priceMinor <= 0n)
            issues.push({ path: "sample.priceMinor", code: "INVALID_PRICE" });
        return issues;
    }
    if (fields.hsCode !== null)
        issues.push({ path: "hsCode", code: "NOT_FOR_SERVICES" });
    if (fields.originCountry !== null)
        issues.push({ path: "originCountry", code: "NOT_FOR_SERVICES" });
    if (fields.sample !== null)
        issues.push({ path: "sample", code: "NOT_FOR_SERVICES" });
    if (fields.availableQuantity !== null)
        issues.push({ path: "availableQuantity", code: "NOT_FOR_SERVICES" });
    if (!SERVICE_AVAILABILITY.includes(fields.availability))
        issues.push({ path: "availability", code: "NOT_FOR_SERVICES" });
    if (fields.serviceRegions === null || fields.serviceRegions.length === 0)
        issues.push({ path: "serviceRegions", code: "REQUIRED" });
    else if (fields.serviceRegions.some((country) => !COUNTRY.test(country)))
        issues.push({ path: "serviceRegions", code: "INVALID_COUNTRY" });
    else if (new Set(fields.serviceRegions).size !== fields.serviceRegions.length)
        issues.push({ path: "serviceRegions", code: "DUPLICATE" });
    return issues;
}
/** English is required in every localized field a listing shows; other languages fall back to it. */
export function localizedIssues(path, text, maxLength) {
    if (text === null || text.en.trim() === "")
        return [{ path: `${path}.en`, code: "REQUIRED" }];
    const issues = [];
    if (text.en.length > maxLength)
        issues.push({ path: `${path}.en`, code: "TOO_LONG" });
    if (text.zh !== undefined && text.zh.length > maxLength)
        issues.push({ path: `${path}.zh`, code: "TOO_LONG" });
    return issues;
}
//# sourceMappingURL=listing.js.map